import { FormControl, FormLabel, FormHelperText, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useFormContext, useController } from 'react-hook-form';

export function ToggleCompetition() {
  const name = 'customer.competition';
  const {
    formState: { errors },
  } = useFormContext();
  const {
    field: { value, onChange },
  } = useController({
    name,
    rules: { required: { message: 'Competition is required', value: true } },
  });
  return (
    <FormControl variant='outlined'>
      <FormLabel>Competition</FormLabel>
      <ToggleButtonGroup color='secondary' exclusive value={value} onChange={(_, value) => onChange(value)}>
        <ToggleButton id={`${name}-SPEC`} value='SPEC'>
          spec
        </ToggleButton>
        <ToggleButton id={`${name}-LOW`} value='LOW'>
          low
        </ToggleButton>
        <ToggleButton id={`${name}-MEDIUM`} value='MEDIUM'>
          medium
        </ToggleButton>
        <ToggleButton id={`${name}-HIGH`} value='HIGH'>
          high
        </ToggleButton>
      </ToggleButtonGroup>
      {errors.customer?.competition && <FormHelperText error>{errors.customer.competition.message}</FormHelperText>}
    </FormControl>
  );
}
